import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {LogementService} from '../../services/logement.service';
import {Observable} from 'rxjs';
import {Logement} from '../../models/logement';
import {NoLogementGuard} from '../../guards/no-logement-guard.service';
import {UserService} from '../../services/user.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-menu-mobile',
    templateUrl: './menu-mobile.component.html',
    styleUrls: ['./menu-mobile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuMobileComponent implements OnInit {
  logementCourantId: number = null;

  @Input() collapsed;

  @Output()
  onToggleMenu = new EventEmitter();

  public previsualisation;

  public logements$: Observable<Logement[]>;
  public logementCourant$: Observable<Logement>;
  public isMCS = false;
  public toggleMenuItems;
  constructor(
    public logementService: LogementService,
    public router: Router,
    public guard: NoLogementGuard,
    private userService: UserService,
    public modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.previsualisation = window.self !== window.top;
    this.logements$ = this.logementService.logements;
    this.logementCourant$ = this.logementService.logementCourant;
    this.logementCourantId = this.logementService.getLogementCourantId();
    this.closeAllSubMenus();
    this.userService.load().then((user) => {
      if (user.isMCS()) {
        this.isMCS = true;
      }
    });
  }

  toggle() {
    this.collapsed = !this.collapsed;
  }

  toggleMenuChilds(item) {
    const val = this.toggleMenuItems[item];
    this.closeAllSubMenus();
    this.toggleMenuItems[item] = !val;
  }
  toggleMenu() {
    this.onToggleMenu.emit();
  }

  logout() {
    sessionStorage.clear();
    return true;
  }

  isSonergiaPartner(logement) {
    return logement?.societe?.partner?.id === environment.SonergiaPartnerId;
  }

  showAnnouncements(logement) {
    if (logement?.societe?.partner?.showAnnouncements === false) {
      return logement?.societe?.partner?.showAnnouncements
    }

    return true
  }

  isParcoursTravauxEnabled() {
    return environment.enableParcoursTravaux
  }

  closeAllSubMenus(){
    this.toggleMenuItems = {
      logement: false,
      equipement: false,
      consommation: false,
      actu_conseil: false,
    };
  }
}
